import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { formatRut, RutFormat } from '@fdograph/rut-utilities';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Validators } from 'ngx-editor';
import { ToastrService } from 'ngx-toastr';
import { MyValidators } from 'src/app/libs/my-validators';
import { ApiEntryControlService } from '../../../api-entry-control.service';
import { atLeastOneDaySelectedValidator } from '../../employees/add-employees/add-employees.component';

@Component({
  selector: 'app-add-visitor',
  templateUrl: './add-visitor.component.html',
  styleUrls: ['./add-visitor.component.css']
})
export class AddVisitorComponent implements OnInit {
  constructor(
    private api: ApiEntryControlService,
    private formBuilder: FormBuilder,
    private toast: ToastrService,
    private modal: NgbModal
  ) { }

  ngOnInit(): void {
    if (this.storesId > 0) {
      this.form1.get('stores_id')?.setValue(this.storesId);
    }
  }

  @Output()
  success = new EventEmitter<boolean>();

  @Input()
  storesId: number;
  form1: FormGroup = this.formBuilder.group({
    name: ['', Validators.required],
    lastname: [''],
    rut: ['', [Validators.required, MyValidators.rut]],
    stores_id: [0],
    state_id: [0],
    date_ing: [],
  }, { validators: atLeastOneDaySelectedValidator() });

  create() {
    this.api.createVisitors(this.form1).subscribe(
      (res) => {
        this.toast.success(res.msg, 'VISITAS');
        this.success.emit(true);
        this.modal.dismissAll();
      },
      (e) => {
        this.toast.warning(e.error.mistakes, e.error.msg, { enableHtml: true, closeButton: true });
      }
    );
  }



  onFormatRut(value: any) {
    if (value.target.value.length > 8) {
      this.form1.get('rut')?.setValue(formatRut(value.target.value, RutFormat.DOTS_DASH));
    }
  }

  openModal(md: any, size = 'md') {
    this.modal.open(md, {
      size: 'xl',
    });
  }
}
